import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LayoutHeaderToolbarAction {
    id: string;
    icon: string;
    tooltip: string;
    ariaLabel?: string;
    color?: 'primary';
    disabled?: boolean;
    handler: () => void;
}

@Injectable({ providedIn: 'root' })
export class LayoutHeaderToolbarService {
    private readonly _actions$ = new BehaviorSubject<LayoutHeaderToolbarAction[]>([]);

    readonly actions$ = this._actions$.asObservable();

    setActions(actions: LayoutHeaderToolbarAction[]): void {
        this._actions$.next(actions);
    }

    clear(): void {
        this._actions$.next([]);
    }
}
